import UserApiBase from "../base/UserApiBase";

import { type AppUserSession } from "@/schemas/auth/session";

export type S3UploadCreds = {
  access_key: string;
  secret_key: string;
  session_token: string;
  expiration: string;
  bucket_name: string;
  region: string;
};

class ResourceService extends UserApiBase {
  public constructor(session: AppUserSession) {
    super("/resource", session);
  }
  public getS3Resource(): Promise<S3UploadCreds> {
    return this.get<S3UploadCreds>("/s3");
  }
}

export default ResourceService;
